export default __webpack_public_path__ + "static/media/logo-mb.47cb7a24.png";